import { Grid } from '@mui/material'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../../Provider'
import { OPAccordionItem } from '../../Accordion/OPAccordionItem'
import { MuiButtonVariants, OPButton } from '../../OPcomponents/OPButton'
import { OPLoadingCircle } from '../../OPcomponents/OPLoadingcircle'
import '../profile.scss'

import EmployersJobTitlesWorkHistoryTable from './EmployersJobTitlesWorkHistoryTable'
import AddNewEmployerJobTitlesProject from './newemployerjobtitlesproject/AddNewEmployerJobTitlesProject'

const EmployersJobTitlesWorkHistory = (props: { rowId: number | undefined }): JSX.Element => {
  const { t } = useTranslation()

  const rootStore = useStore()
  const { rowId } = props
  const { filteredEmployersJobTitlesWorkHistories, employersJobTitlesWorkHistoryLoading } = rootStore.personStore
  const {
    showAddEmployerJobTitlesProjectModalHandler,
    showAddEmployerJobTitlesProjectModal,
    showAddProjectModal,
    loadingEmployerDetails,
    loadingInitial,
    showAddPrivateProjectModal,
  } = rootStore.projectStore
  return (
    <Grid container item display='flex'>
      <Grid container item className='gridcontainer--certedu__addbuttonmargin'>
        <Grid item className='griditem--addbutton'>
          <OPButton
            disabled={showAddEmployerJobTitlesProjectModal || showAddProjectModal || showAddPrivateProjectModal}
            label={t('Buttons.AddNewEmploymentRole')}
            buttonVariant={MuiButtonVariants.primary_outlined}
            onClick={() => showAddEmployerJobTitlesProjectModalHandler(true)}
          />
        </Grid>
      </Grid>
      <OPAccordionItem
        setOutsideExpanded={showAddEmployerJobTitlesProjectModal || rowId !== undefined}
        title={`${t('WorkHistory.EmployersJobTitlesHeader')} (${
          employersJobTitlesWorkHistoryLoading ? '\u2026' : filteredEmployersJobTitlesWorkHistories.length
        })`}
        content={
          <Grid container className='gridcontainer--workhistory__formpadding'>
            {showAddEmployerJobTitlesProjectModal && (
              <>
                <Grid item xs={12} className='griditem--formitem__zindex'>
                  <AddNewEmployerJobTitlesProject isCreateNewProject={true} />
                </Grid>
              </>
            )}
            <Grid item xs={12}>
              {loadingEmployerDetails || employersJobTitlesWorkHistoryLoading || loadingInitial ? (
                <OPLoadingCircle />
              ) : (
                <EmployersJobTitlesWorkHistoryTable rowId={rowId} />
              )}
            </Grid>
          </Grid>
        }
      />
    </Grid>
  )
}

export default observer(EmployersJobTitlesWorkHistory)
